import "../OneWord/oneWord.css";
import "./Question.css";
import { useEffect, useState } from "react";
import EditCard from "../../EditCard/EditCard";
import QuestionChecker from "./QuestionChecker";

import { htmlDecode } from "../../../utils/parse";
import { QuestionImg, QuestionMedia } from "./Component";
import CognitiveIcon from "./Component/CognitivieIcon";
import DifficultyIcon from "./Component/DifficultyIcon";

export default function Descriptive({
  isPraticeSession,
  isChecked,
  question,
  index,
  deleteQuestion,
  setQuestId,
  setSelQuest,
  isMarks,
  page,
  ap
}) {
  const [edit, setEdit] = useState(false);
  const openEdit = () => setEdit(true);
  const closeEdit = () => setEdit(false);

  const [input, setInput] = useState({ blankId: "op1", answer: "" });

  function handleInput(e) {
    setInput({
      blankId: e.target.name,
      answer: e.target.value,
    });
  }

  useEffect(() => {
    if (window.MathJax) window.MathJax.typesetPromise();
  }, [question.question]);

  return (
    <>
      {edit && (
        <EditCard
          edit={edit}
          closeEdit={closeEdit}
          quesType="oneword"
          question={question}
          setQuestId={setQuestId}
          setSelQuest={setSelQuest}
          isMarks={isMarks}
          assessmentType="competency"
        />
      )}
      <div
        className={
          isChecked
            ? "my-4 question-c onlineQuestionCard"
            : "my-4 question-c questionCard"
        }
        style={{ display: edit ? "none" : "block" }}
      >
        <div className="superhead">
          <div
            className={
              isPraticeSession ? "remark ps_remark" : "remark ot_remark"
            }
          >
            HOTS Question
          </div>
          <div
            className={
              isPraticeSession
                ? "one__head ps_mcq_head"
                : "one__head ot_mcq_head"
            }
          >
            <QuestionChecker
              isStaff={question.onModel === "staff"}
              type={question.questionType}
              options={question.options}
              correctAnswers={question.correctAnswers[question.questionType]}
              answers={input}
              reset={() => setInput({ blankId: "op1", answer: "" })}
              editMode={edit}
              openEdit={openEdit}
              delete={() => deleteQuestion(question._id)}
              isPraticeSession={isPraticeSession}
              staff={{
                name: question.creatorId?.name,
                schoolName: question.schoolId?.name,
              }}
            >
              <div className="oneCard">
                <div
                  className="oneCard__left"
                  style={
                    isPraticeSession ? { marginTop: "16px" } : { marginTop: "" }
                  }
                >
                  <div style={{ minWidth: "fit-content" }}>
                    Q{5 * (page - 1) + index}.&nbsp;
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(question.question),
                    }}
                  ></div>
                </div>
                {question.cognitive?<div className="oneCard__right">
                                <span
                                  className={
                                    isPraticeSession
                                      ? "difficulty_status bg_ps"
                                      : "difficulty_status bg_ot"
                                  }
                                >
                                  <CognitiveIcon/>
                                  {question.cognitive}
                                </span>
                                </div>:null}
              </div>

              <div
                className="question-body"
                style={
                  question.images?.questionImg
                    ? { justifyContent:"start" }
                    : { justifyContent: "unset" }
                }
              >
                {question.images?.questionImg ? (
                  <QuestionMedia url={question.images?.questionImg} />
                ) : null}
                <textarea
                  className={isPraticeSession ? "ps-op1" : "ot-op1"}
                  style={{ marginRight: "20px" }}
                  name={"op1"}
                  value={input.answer}
                  onChange={handleInput}
                />
              </div>
            </QuestionChecker>
          </div>
        </div>
      </div>
    </>
  );
}
